/**
 * RetrieveClaims from BFF & GW
*/
import { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Formio } from '@formio/react';
import { getClaims, getGWClaims } from '../../redux/Claims/actions';
import { authenticationDataSelector } from '../../redux/Authentication/selector';
import { clearPolicyDetails } from '../../redux/PolicyDetails/actions';
import { clearServicesState } from '../../redux/Services/actions';
import { setFive9BusinessHours } from '../../services/five9Service';

function RetrieveClaims(props) {
  const { authentication } = props;
  const { sonnetAddressBookUid } = authentication;
  const dispatch = useDispatch();

  useEffect(() => {
    if (sonnetAddressBookUid) {
      dispatch(clearServicesState());
      dispatch(getClaims());
      dispatch(getGWClaims());
      dispatch(clearPolicyDetails());
      setFive9BusinessHours();
    }
    Formio.forms = {};
  }, [dispatch, sonnetAddressBookUid]);

  return true;
}

const mapStateToProps = (state) => ({
  authentication: authenticationDataSelector(state.authentication),
});

export default connect(mapStateToProps)(RetrieveClaims);
